import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as fullStar } from '@fortawesome/free-solid-svg-icons'
import { isPastDate } from '../../../utils/utils';
import { Link } from 'react-router-dom';

export default function ProductCard({ product }) {
    return (
        <Link
            to="/productDetails"
            state={{ product: product }} >
            <div key={product.id} className="bg-white rounded-2xl shadow-md py-6 flex flex-col items-center 
            justify-center p-2 hover:bg-gray-100 transition-colors duration-200 cursor-pointer">
                <img src={product.images[0]} alt={product.name} className="w-full h-40 object-cover mb-4" />
                <h3 className="text-xl font-semibold mb-2 text-dark-text-color text-center overflow-hidden overflow-ellipsis line-clamp-2">
                    {product.name}
                </h3>
                <div className="flex items-center justify-center gap-1 mb-4">

                    <span className="ml-2 text-sm text-gray-600">
                        {product.ratings || 0} <FontAwesomeIcon icon={fullStar} color='orange' /> ({product.ratingsCount || 0})
                    </span>
                    <span className="ml-2 text-sm text-gray-600">
                        Sold ({product.soldCount || 0})
                    </span>
                </div>


                <div className="text-center flex justify-center items-center gap-4">
                    <div className="text-center mb-4">
                        {isPastDate(product.variants[0].timeForSpecialPrice) === true ? (
                            <p className="text-lg">PKR {product.variants[0].price}</p>
                        ) : (
                            <>
                                <p className="text-base line-through text-light-text-color">PKR {product.variants[0].price}</p>
                                <p className="text-lg text-bright-green">PKR {product.variants[0].specialPrice}</p>
                            </>
                        )}
                    </div>

                    {/* Two Buttons for WishList And Add TO Cart */}
                    <div></div>


                </div>
            </div>
        </Link>
    );
};
